// extracted by mini-css-extract-plugin
module.exports = {"TextArea":"TextArea_TextArea__2QzFx","TextArea__Label":"TextArea_TextArea__Label__3tup_"};